import { Box, Button, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../Hooks/useHandleApiResponse';

export default function GlobalDeleteDialogueContent({
  content,
  sx = { minWidth: 300 },
  cancel,
  setOpen,
  deleteDispatchParams,
  dispatchDeleteFn,
  onSuccess,
  onSuccessDispatchFn,
  successDispatchParams,
  onFailed,
  loading,
  contentStyle = { fontWeight: 500 },
}) {
  const dispatch = useDispatch();
  const handleResponseApi = useHandleApiResponse();

  const handleDelete = () => {
    dispatch(dispatchDeleteFn(deleteDispatchParams)).then((res) => {
      handleResponseApi(res, {
        onSuccess: () => {
          if (onSuccess) onSuccess();
          if (onSuccessDispatchFn) dispatch(onSuccessDispatchFn(successDispatchParams));
          setOpen(false);
        },
        onFailed,
      });
    });
  };

  return (
    <Box display={'flex'} flexDirection={'column'} gap={3} sx={sx}>
      <Typography sx={contentStyle}>{content}</Typography>
      <Box
        display={'flex'}
        sx={{
          alignSelf: 'flex-end',
          gap: 1,
        }}
      >
        {cancel && (
          <Button variant="outlined" onClick={() => setOpen(false)}>
            cancel
          </Button>
        )}
        <Button color="error" variant="contained" onClick={() => handleDelete()} disabled={loading ?? false}>
          {loading ? (loading ? 'deleting...' : 'delete') : 'delete'}
        </Button>
      </Box>
    </Box>
  );
}
